import Box from '@mui/material/Box';
import { useFileManagerModalInputDialogContentContext } from './FileManagerModalInputDialogContentProvider';
import Breadcrumbs from '@mui/material/Breadcrumbs';

interface FileManagerModalInputDialogListBreadcrumbProps {
}

const FileManagerModalInputDialogListBreadcrumb = (_props: FileManagerModalInputDialogListBreadcrumbProps) => {
  const { group, setGroup, sub, setSub } = useFileManagerModalInputDialogContentContext();

  // console.log(group, sub);
  const onRootClick = () => {
    setGroup(group);
    setSub([]);
  }
  const onLinkClick = (sub: Array<string>) => {
    setSub(sub);
  }

  return (
    <Box style={{ height: 45, paddingLeft: 20, paddingTop: 3, overflowX: 'scroll' }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ "& .MuiBreadcrumbs-ol": { flexWrap: 'nowrap' } }}>
        <button style={{ background: 'none', border: 'none', cursor: 'pointer', }} onClick={onRootClick}>{("" === group ? "Root" : group).toUpperCase()}</button>
        {sub.map((s, si) =>
          (sub.length - 1) === si
            ? <span key={si}>{s}</span>
            : <button style={{ background: 'none', border: 'none', cursor: 'pointer', }} key={si} onClick={() => onLinkClick(sub.slice(0, si))}>{s}</button>
        )}
      </Breadcrumbs>
    </Box>
  )
}

export default FileManagerModalInputDialogListBreadcrumb;
